// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"062d7a11","453":"d87d5cf5"}[chunkId] + ".chunk.js";
};